import React from "react";
import ReactDOM from "react-dom/client";
import "../css/tw-styles.css";
import fieldBgImage from "../images/fieldBg.png";
import fuelLikeRonLogo from "../images/fuelLikeRon.png";
import herbalifeLogo from "../images/HerbaLifeLogo.png";
import { SubmitResultString } from "../../Common/js/OS.1.0.4.0.js";
import { useSubmitOnce } from "./useSubmitOnce.js";

function App() {
  const handleStart = useSubmitOnce(() => {
    SubmitResultString("");
  });

  return (
    <div
      className="w-screen h-screen flex flex-col items-center justify-between py-12 sm:py-16 overflow-hidden"
      style={{
        backgroundImage: `url(${fieldBgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "top center"
      }}
    >
      {/* Top: Fuel Like Ronaldo logo */}
      <div className="flex items-center justify-center flex-1">
        <img
          src={fuelLikeRonLogo}
          alt="Fuel Like Ronaldo"
          className="w-[90%] sm:w-3/4 max-w-2xl object-contain"
        />
      </div>

      {/* Center: Start button */}
      <div className="flex items-center justify-center flex-1">
        <button
          onClick={handleStart}
          className="bg-white text-[#F2A900] text-3xl sm:text-4xl uppercase tracking-wide px-20 sm:px-28 py-5 sm:py-7 rounded"
          style={{ fontFamily: "WalsheimGT", fontWeight: 700 }}
        >
          START
        </button>
      </div>

      {/* Bottom: Herbalife logo */}
      <div className="flex items-end justify-center">
        <img src={herbalifeLogo} alt="Herbalife" className="w-48 sm:w-64 object-contain" />
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.querySelector("#app")).render(<App />);
